import { render, staticRenderFns } from "./IngredientSearch.vue?vue&type=template&id=cf8ddbaa&scoped=true&"
import script from "./IngredientSearch.vue?vue&type=script&lang=js&"
export * from "./IngredientSearch.vue?vue&type=script&lang=js&"
import style0 from "./IngredientSearch.vue?vue&type=style&index=0&id=cf8ddbaa&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8ddbaa",
  null
  
)

export default component.exports